
// Transform 'fr-FR' to 'fr', 'en-US' to 'en' .... ect
export function langageCultureToLanguage(langCulture: string): string {
  return langCulture?.split('-')[0]?.toLocaleLowerCase();
}
